// extracted by mini-css-extract-plugin
export default {"sizing":"SignIn_sizing__Ha8Tl","heading":"SignIn_heading__fhrTk"};